import React from 'react'
import ModalSimple from './ModalSimple'
import ModalContent from './ModalContent'

interface ModalCustomProps {
  title?: React.ReactNode
  closeModal?: () => void
  footerTemplate?: React.ReactNode
  children?: React.ReactNode
  size?: string
  dataTest?: string
  className?: string
}

const ModalCustom: React.FC<ModalCustomProps> = ({
  title,
  closeModal,
  footerTemplate,
  children,
  size = 'lg',
  dataTest,
  className = '',
}) => {
  return (
    <ModalSimple size={size} dataTest={dataTest} className={className}>
      <ModalContent title={title} closeModal={closeModal} footerTemplate={footerTemplate}>
        {children}
      </ModalContent>
    </ModalSimple>
  )
}

export default ModalCustom
